module.exports = __webpack_public_path__ + "static/img/znq0515.45a5968.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znq0515.jpg
// module id = QJCS
// module chunks = 0